import React from "react";
import { Link } from "react-router-dom";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const pageNumber = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <>
      <nav aria-label="...">
        <ul className="pagination pagination-sm justify-content-end">
          {pageNumber().map((number) => (
            <li
              className={`page-item ${number === currentPage ? "active" : ""}`}
              key={number}
              aria-current="page"
              onClick={() => onPageChange(number)}
            >
              <Link className="page-link">{number}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Pagination;
